<template>
  <section
    v-if="recentlyDeleted"
    :class="$style.banner"
  >
    <ParagraphBody
      bodySize="large"
    >
      {{ message }}
    </ParagraphBody>
  </section>
</template>

<script>
import { ParagraphBody } from '@jumpcloud/ui-components';

export default {
  name: 'DeletedOrgBanner',
  components: {
    ParagraphBody,
  },
  data() {
    return {
      message: '😭 We are sorry to see you go. You are always welcome back - just sign up again with your company email!',
    };
  },
  computed: {
    recentlyDeleted() {
      const orgDeletedDate = JSON.parse(localStorage.getItem('orgDeletedDate'));
      const expiryDate = new Date().getTime() - (5 * 60 * 1000); // 5 minute expiry
      return orgDeletedDate && orgDeletedDate >= expiryDate;
    },
  },
};
</script>

<style module>
  .banner {
    background-color: #FFF5E0;
    padding: 1rem 2rem;
    position: relative;
    text-align: center;
    width: 100%;
  }
</style>
